module.exports = __webpack_public_path__ + "static/media/vinit-shahdeo.db1bd75d.jpg";